import PersonGroupMemberships from './PersonGroupMemberships';

export default PersonGroupMemberships;
